<template>
    <div>
        <CCard class="status-style">
            <CCardHeader>Connection Status</CCardHeader>
            <CCardBody>
            <span v-if="! onnet">You are not on a soldiernet network.</span>
            <span v-if="onnet">You are on a soldiernet network.</span>
            </CCardBody>
        </CCard>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { checkMyStatus } from 'src/cpd'

export default {
  computed: {
    ...mapState('captive', ['onnet'])
  },
  created: function () {
    // check to see if the device is connected as far as cpd is concerned
    if (this.onnet) {
        
        let rd = checkMyStatus()
        this.$log.onDebug("status:" + JSON.stringify(rd))
        // rd { connected: bool, session: {} }
        
    }

  },  

}
</script>

<style lang="scss" scoped>

.status-style {
  border-radius: 10px 10px 10px 10px !important;
}

.card-header:first-child {
  border-radius: 2rem 2rem 0 0;
}

</style>

